import type { Edge } from "@xyflow/react"
import type { AppNode, EdgeData } from "@features/builder/graph/types"
import {
  areLagsValid,
  getVisibleEdge,
  hasEdgeCycle,
  hasTargetNodeLink,
  isGroupNode,
  isInvalidConnection,
  isSourceMissingUbound,
} from "@features/builder/helpers/edges"
import { MaybeConnection } from "@features/builder/CreateEdges/types"

export const MAX_SELECTED_NODES = 20

export function getMaybeConnections({
  parents,
  children,
  allNodes,
  allEdges,
}: {
  parents: AppNode[]
  children: AppNode[]
  allNodes: AppNode[]
  allEdges: Edge<EdgeData>[]
}): MaybeConnection[] {
  const connections: MaybeConnection[] = []
  for (const parent of parents) {
    for (const child of children) {
      if (isGroupNode(parent) || isGroupNode(child)) {
        // omit if parent/child is a group
        continue
      }

      const errors: string[] = []
      if (hasEdgeCycle({ target: child, source: parent, nodes: allNodes, edges: allEdges })) {
        errors.push("This connection creates a cycle")
      }
      if (hasTargetNodeLink(child)) {
        errors.push("Target node cannot have link.")
      }
      if (!areLagsValid({ source: parent, target: child })) {
        errors.push("Child lag is greater than parent lag")
      }
      if (isInvalidConnection({ source: parent, target: child })) {
        errors.push("Incompatible node types")
      }
      if (isSourceMissingUbound({ source: parent, target: child })) {
        errors.push("Parent node has no ubound set")
      }
      if (getVisibleEdge(parent.id, child.id, allEdges)) {
        errors.push("These nodes are already connected")
      }

      connections.push({
        parent,
        child,
        isSelected: errors.length === 0,
        errors,
      })
    }
  }
  return connections
}
